import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { HOLIDAYS } from '../constants'
import { HolidayFormInput } from '../types'
import { transformHolidayInput } from '../utils'

const createHoliday = async (form: HolidayFormInput) => {
  await fetchAPI({
    method: 'post',
    path: '/holidays',
    data: transformHolidayInput(form),
  })
}

export const useCreateHoliday = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(createHoliday, {
    onSuccess: async () => {
      await queryClient.refetchQueries([HOLIDAYS])

      toast({
        description: t('views.admin.holidays.services.create_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
